/**
 * 上传组件常量定义
 */

export const MEDIA_LIMIT_TYPE = {
  LIMIT_SIZE: 'File size larger than the limit',
  LIMIT_SIZE_RANGE: 'File size is not in the limit range',
  LIMIT_RATIO: 'Aspect ratio of file mismatch',
  LIMIT_RATIO_RANGE: 'Aspect ratio of the file is not in the limit range',
  LIMIT_DURATION: 'Video time larger than the limit',
  LIMIT_DURATION_RANGE: 'File duration is not in the limit range',
  LIMIT_CODE_RATE: 'Bitrate larger than the limit',
  LIMIT_CODE_RATE_RANGE: 'Bitrate is not in the limit range',
  FAIL_GET_FILE_INFO: 'Failed to get file info',
  UPLOAD_ERROR: 'Upload failed, please try again',
} as const;

export type MediaLimitType = typeof MEDIA_LIMIT_TYPE[keyof typeof MEDIA_LIMIT_TYPE];

export const DEFAULT_UPLOAD_TYPE = 'default';
export const DRAGGER_UPLOAD_TYPE = 'dragger';

export type UploadType = typeof DEFAULT_UPLOAD_TYPE | typeof DRAGGER_UPLOAD_TYPE;
